import React, { useState } from "react";
import Navbar from "../../Includes/Navbar/Navbar";
import Sidebar from "../../Includes/Sidebar/Sidebar";
import FootfallGenderReport from "./FootfallGenderReport";
import FootfallBranchReport from "./FootfallBranchReport";
import FootfallPeakReport from "./FootfallPeakReport";
import FootfallCombinedReport from "./FootfallCombinedReport";

const TABS = [
  { id: "gender", label: "Gender", icon: "bi-gender-ambiguous" },
  { id: "branch", label: "Branch", icon: "bi-building" },
  { id: "peak", label: "Peak Hours", icon: "bi-clock-history" },
  { id: "combined", label: "Combined", icon: "bi-pie-chart" },
];

export default function FootfallReport() {
  const [tab, setTab] = useState("gender");

  const renderPanel = () => {
    switch (tab) {
      case "gender":
        return <FootfallGenderReport embedded />;
      case "branch":
        return <FootfallBranchReport embedded />;
      case "peak":
        return <FootfallPeakReport embedded />;
      case "combined":
        return <FootfallCombinedReport embedded />;
      default:
        return null;
    }
  };

  return (
    <div className="wrapper">
      <Navbar />
      <Sidebar />
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <div className="container-fluid">
            <h5 className="mb-3 font-20">Footfall Report</h5>
            <ul className="nav nav-tabs mb-3 flex-wrap border-bottom">
              {TABS.map((t) => (
                <li className="nav-item" key={t.id}>
                  <button
                    type="button"
                    className={`nav-link ${tab === t.id ? "active" : ""}`}
                    onClick={() => setTab(t.id)}
                  >
                    <i className={`bi ${t.icon} me-1`} />
                    {t.label}
                  </button>
                </li>
              ))}
            </ul>
            {renderPanel()}
          </div>
        </div>
      </main>
    </div>
  );
}
